<template>
  <b-container fluid>
    <div class="d-none d-md-block">
      <sidebar
        id="desktop-sidebar"
        :title="company.name"
        :tabs="tabs"
        :isMobile="false"
      />
    </div>
    <div class="d-block d-md-none">
      <sidebar
        id="mobile-sidebar"
        :title="company.name"
        :tabs="tabs"
        :isMobile="true"
      />
    </div>
    <router-view></router-view>
  </b-container>
</template>
<script>
import { mapState } from 'vuex';

export default {
  components: {
    sidebar: () => import('@/components/Sidebar')
  },
  data () {
    return {
      currentTab: "dashboard",
      tabs: [
        {
          title: 'Dashboard',
          name: 'companyDashboard',
          icon: 'columns-gap',
        },
        { 
          title: 'Jobs',
          name: 'companyJobs',
          icon: 'briefcase',
          query: {}
        },
        { 
          title: 'Info',
          name: 'companyInfo',
          icon: 'pencil',
        }
      ]
    };
  },
  computed: mapState({
    company: state => state.company.data
  }),
  created(){
    this.tabs[1].query.id = this.company.uid
  }
};
</script>
